export default "__VITE_ASSET__COu20REk__"